GP.vent.on('init_js:user:home', function(self) {
    // popup tracking/increment
    if ($.cookie('next_sequence')) {
        var next_sequence = parseInt($.cookie('next_sequence'), 10);
        GP.Util.set_cookie('next_sequence', (next_sequence + 1), 2);
    }

    // flirt popup
    if (typeof(show_flirt) != 'undefined' && show_flirt) {
        GP.vent.trigger('Modal:open', {
            url: "/members/user/flirt/",
            auto_trigger: true
        });
    }

    // flirt center
    $("#btn-send-flirts").on("click", function(e){
        var msg = $("select[name='flirt_center_message'] option").filter(':selected');
        if (msg) {
            $.post('/members/user/send_flirt_message/', {flirt_msg_index: msg.val()}, function(data) {
                $('#flirt_center_send').hide();
                $('#flirt-center-success').show();
                $("select[name='flirt_center_message']").attr("disabled","disabled");
            });
        }
    });

    if (typeof show_ice_breaker != 'undefined' && show_ice_breaker) {
        GP.vent.trigger('Modal:open', {
            url: "/members/user/ice_breaker/",
            auto_trigger: true
        });
    }

    // streamate carousel
    self.populate_stream_div = function() {
        var sm_arr = $.parseJSON(sm_data);
        var sm_html = '<ul class="home-media-list list-unstyled">';
        var sm_obj = {};

        for (var i = 0; i < 4; i++) {
            if (!sm_arr[sm_pos]) {
                sm_pos = 0;
            }

            sm_obj = sm_arr[sm_pos] || { thumb: '', name: '' };

            sm_html += '<li class="thumb-wrap' + i + '">';
            sm_html += '<div class="text-live-now"><img src="//cachemd.cdnhost2000xl.com/images/ico_chatting_green.png">&nbsp;' + sm_live_now_text + '</div>';
            sm_html += '<a class="no-follow" href="/members/oneclick/flinglivegirls?camname=' + sm_obj.name + '&afno=60&purchase_modal=1" target="_new">';
            sm_html += '<img src="//m1.nsimg.net/' + sm_obj.thumb + '" class="thumb">';
            sm_html += '</a>';
            sm_html += '<p class="username">' + sm_obj.name + '</p>';
            sm_html += '</li>';

            sm_pos++;
        }

        sm_html += '</ul>';

        $('#streamate-carousel').html(sm_html);
    };
    self.handle_sm_fadein = function() {
        $('#streamate-carousel').delay(5000).fadeOut(500, self.handle_sm_fadeout);
    };
    self.handle_sm_fadeout = function() {
        self.populate_stream_div();
        $('#streamate-carousel').fadeIn(500, self.handle_sm_fadein);
    };

    if (typeof(sm_data) != 'undefined' && sm_data) {
        self.populate_stream_div();
        $('#streamate-carousel').delay(5000).fadeOut(500, self.handle_sm_fadeout);
    }


    // camsoda carousel
    self.show_camsoda_cams = function() {
        var cs_html = '<ul class="home-media-list list-unstyled">';
        var cs_obj = {};

        for (var i = 0; i < 4; i++) {
            if (!cs_cams_data[cs_pos]) {
                cs_pos = 0;
            }

            cs_obj = cs_cams_data[cs_pos] || { thumb: '', name: '' };
            cs_cam_link = GP.Util.clean_url('/members/user/live_action_link/', {model : cs_obj.username});

            cs_html += '<li class="thumb-wrap' + i + '">';
            cs_html += '<a class="no-follow" href="' + cs_cam_link + '">';
            cs_html += '<div class="text-live-now"><span class="ico-online-green ico-online-green-default"></span>' + cs_live_now_text + '</div>';
            cs_html += '<img src="' + cs_obj.thumb + '" class="thumb">';
            cs_html += '<p class="username">' + cs_obj.name + '</p>';
            cs_html += '</a>';
            cs_html += '</li>';
            cs_pos++;
        }

        cs_html += '</ul>';

        $('#camsoda-carousel').html(cs_html);

        // set a fixed height on the live cams div to prevent
        // the page shifting when images are fading in/out.
        setTimeout(function() {
            let cams_div = $('#camsoda-carousel');
            let cams_div_height = cams_div.height();

            if (cams_div_height > 80) {
                cams_div.css('height', cams_div_height);
            }
        }, 1500);
    };
    self.handle_cs_fadein = function() {
        $('#camsoda-carousel').delay(5000).fadeOut(500, self.handle_cs_fadeout);
    };
    self.handle_cs_fadeout = function() {
        self.show_camsoda_cams();
        $('#camsoda-carousel').fadeIn(500, self.handle_cs_fadein);
    };
    if (typeof(cs_cams_data) != 'undefined' && cs_cams_data) {
        self.show_camsoda_cams();
        $('#camsoda-carousel').delay(5000).fadeOut(500, self.handle_cs_fadeout);
    }


    // premium movies footer
    self.swap_footer_ads = function(show_section, clicked_tab) {
        var sections = ['mow','movies'/*,'cams'*/];

        // swap section
        for(var i=0; i<sections.length; i++)
        {
            var section = $('#'+sections[i]);
            $(section).hide();

            if(show_section == sections[i])
            {
                $(section).show();
            }
        }

        // update tab
        $('.active').removeClass('active');
        $(clicked_tab).parent().addClass('active');
    };
    $('#premium-movies-wrap .movies').click(function(e) {
        self.swap_footer_ads('movies', e);
    });
    $('#premium-movies-wrap .mow').click(function(e) {
        self.swap_footer_ads('mow', e);
    });

    // search
    var search_location_type;
    self.change_country = function() {
        var country_select = document.getElementById('country');
        if (!country_select) {
            return;
        }

        var country_code = country_select.options[country_select.selectedIndex].value;
        var loc_div  = document.getElementById('loc_div');
        var city_div = document.getElementById('city_div');
        var loc_label  = document.getElementById('loc_label');
        var loc_label2  = document.getElementById('loc_label2');
        var location_id    = document.getElementById('location_id');
        var city_name      = document.getElementById('city_name');
        if ( country_code == 'US' || country_code == 'CA' ) {
            city_name.value = '';
            search_location_type = 'local';
            city_div.style.display = 'none';
            loc_div.style.display  = 'block';
            if ( country_code == 'US' ) {
                loc_label2.innerHTML = language.city_or_zip;
            } else if(country_code == 'CA') {
                loc_label2.innerHTML = language.city_or_postal;
            }
        } else {
            location_id.value = '';
            search_location_type = 'intl';
            loc_label2.innerHTML = language.city_name;
            city_div.style.display = 'block';
            loc_div.style.display  = 'none';
        }
    };
    self.do_search = function() {
        var search_a       = document.getElementById('search_a');
        var search_qs      = document.getElementById('search_qs');
        var search_gender  = document.getElementById('search_gender');
        var search_seeking = document.getElementById('search_seeking');
        var search_form    = document.getElementById('search_form');
        var location_id    = document.getElementById('location_id');
        var city_name      = document.getElementById('city_name');

        var qs_option = search_qs.value.split('_');
        search_gender.value = qs_option[0];
        search_seeking.value = qs_option[1];
        search_qs.value = '';

        if ( search_location_type == 'local' ) {
            search_a.value = 'search.quicksearch';
            city_name.value = '';
            search_form.submit();
        } else if ( search_location_type == 'intl' ) {
            search_a.value = 'search.intl_bridge';
            location_id.value = '';
            search_form.submit();
        } else {
            return false;
        }
    };
    self.show_search_box = function(search_box_id) {
        var quicksearch_box = document.getElementById('quicksearch_box');
        var username_search_box = document.getElementById('username_search_box');
        quicksearch_box.style.display = 'none';
        username_search_box.style.display = 'none';
        document.getElementById(search_box_id).style.display = 'block';
    };

    // TEMPORARY
    $('#hide-fl3-banner').click(function(e) {
        e.preventDefault();
        GP.Util.set_cookie('fl3', 1, 365);
        $(this).closest('div.alert').remove();
    });

    $('.btn-home-toggle-hide').click(function(e) {
        e.preventDefault();
        GP.Util.set_cookie('fl_hide_hm_tgl', 1, 365);
        $('.home-toggle-wrap').hide();
    });

    $('.user-status-select .dropdown-menu li a').on('click', function(e) {
        var $el = $(this);
        var status_text = $el.data('text');
        var status_id = $el.data('status_id');
        var reset_status = $el.data('reset');
        var default_text = $('.user-status-select > a').data('default-text');

        if (reset_status) {
            $('.user-status-select > a').text(default_text);
            GP.vent.trigger('User:reset_user_status');
        } else if (status_text && status_id) {
            GP.vent.trigger('User:update_user_status', status_id);

            $('.user-status-select > a').text(status_text);
            $('.user-status-wrap .search-link-wrap > a').attr('href',
                '/members/search/quicksearch/?search_type=user_status&status_id=' + status_id
            );
            $('.user-status-wrap .search-link-wrap .status-text').text(status_text);

        }
    });

    $('#cs-nag-close, #nag-test-link').click(function(e) {
        $('.alert-camsoda-token-nag').hide();
        GP.Util.set_cookie('fl_cs_lnk', 0, 1);
    });


    $('#city_name').typeahead({
        items: "all",
        minLength: 3,
        source: function(query, process) {
            var country_code = $('#country option:selected').val();
            return $.get('/members/geo/suggest_city/?jq=1&country_code='+country_code, { location_name: query }, function(data) {
                loc_obj = {};
                var names = [];
                $.map(data, function(val, i) {
                    if (Boolean(val.desc)) {
                        loc_obj[val.desc] = val.location_id;
                        names.push(val.desc);
                    }
                });
                return process(names);
            });
        },
        updater: function(name) {
            $('#location_id').val(loc_obj[name]);
            return name;
        }
    });

    // if the user doesn't click the typeahead suggestion the location_id wont get set
    // try to set it on blur if the input has a valid zip code (doesn't work for city name)
    $('#city_name').blur(function() {
        var val = $(this).val();
        if (val.length) {
            $.each(loc_obj, function(location_desc, location_id) {
                if (location_id == val) {
                    $('#location_id').val(location_id);
                }
            });
        } else {
            $('#location_id').val('');
        }
    });

    GP.vent.trigger('User:setup_verified_tooltip', $('.verified-badge .verified'));

});

